export const HANDOFF_REASON_CATEGORIES = [
  {
    key: "REASSIGNED_TO_CORRECT_OWNER",
    label: "Reassigned to correct owner",
    sublabel: "initial assignment was incorrect",
    requiresNote: false,
    countsAsInsufficientProgress: false,
  },
  {
    key: "CURRENT_HOLDER_UNAVAILABLE",
    label: "Current holder unavailable",
    sublabel: "leave, travel, or absence",
    requiresNote: false,
    countsAsInsufficientProgress: false,
  },
  {
    key: "WORKLOAD_REBALANCING",
    label: "Workload rebalancing",
    sublabel: "",
    requiresNote: false,
    countsAsInsufficientProgress: false,
  },
  {
    key: "CHANGE_IN_SCOPE_OR_PRIORITIES",
    label: "Change in scope or priorities",
    sublabel: "",
    requiresNote: false,
    countsAsInsufficientProgress: false,
  },
  {
    key: "INSUFFICIENT_PROGRESS",
    label: "Insufficient progress",
    sublabel: "non-responsive or stalled",
    requiresNote: true,
    countsAsInsufficientProgress: true,
  },
  {
    key: "OTHER",
    label: "Other",
    sublabel: "please specify",
    requiresNote: true,
    countsAsInsufficientProgress: false,
  },
  {
    key: "ESCALATED_PENDING_REVIEW",
    label: "Escalate as dropped-the-ball",
    sublabel: "needs C-suite confirmation; reassign now, KPI flag pending",
    requiresNote: true,
    countsAsInsufficientProgress: false,
  },
] as const;

export type HandoffReasonCategory = typeof HANDOFF_REASON_CATEGORIES[number]["key"];

export const HANDOFF_REASON_KEYS: HandoffReasonCategory[] = HANDOFF_REASON_CATEGORIES.map((c) => c.key);

export function getHandoffReason(key: string) {
  return HANDOFF_REASON_CATEGORIES.find((c) => c.key === key);
}

export function isInsufficientProgress(key: string | null | undefined): boolean {
  if (!key) return false;
  const cat = getHandoffReason(key);
  return !!cat?.countsAsInsufficientProgress;
}

export function isEscalationPendingReview(key: string | null | undefined): boolean {
  return key === "ESCALATED_PENDING_REVIEW";
}
